<template>
  <div class="isis-dropdown-btn">
    <drop-down direction="down">
      <md-button
        slot="title"
        class="dropdown-toggle"
        data-toggle="dropdown"
        :class="[btnClasses]"
      >
        {{ $t(title) }}

        <slot name="prefix-icon">
          <!-- <i class="prefix-icon fas fa-chevron-down"></i> -->
          <md-icon class="prefix-icon">expand_more</md-icon>
        </slot>
      </md-button>
      <ul class="dropdown-menu" :class="[menuClasses]">
        <li v-for="(item, idx) in actions" :key="idx">
          <a v-if="item.disable" href="javascript:" class="disabled-link">{{
            $t(item.content) || `Action ${idx}`
          }}</a>
          <a v-else @click.prevent="item.action">{{
            $t(item.content) || `Action ${idx}`
          }}</a>
        </li>
      </ul>
    </drop-down>
  </div>
</template>

<script>
export default {
  props: ["title", "btnClasses", "actions", "rightMenu"],
  computed: {
    menuClasses() {
      return this.rightMenu ? "dropdown-menu-right" : "dropdown-menu-left";
    }
  }
};
</script>

<style lang="scss">
// ISIS OVERRIDE CSS

.isis-dropdown-btn {
  max-height: 100%;
  .dropdown {
    button.dropdown-toggle {
      border-radius: 100px;
    }
    .dropdown-toggle + .dropdown-menu {
      top: 115%;
      li {
        cursor: pointer;
      }
    }

    .dropdown-toggle {
      .md-ripple {
        padding-left: 16px !important;
        padding-right: 10px !important;
      }
      .prefix-icon {
        display: inline-block;
        font-size: inherit;
        // font-weight: 400;
        // margin-left: 8px;
      }

      i {
        transition: 0.15s;
        will-change: transform;
      }
    }

    &.open {
      .dropdown-toggle {
        .prefix-icon {
          transform: rotate(180deg);
        }
      }
    }
  }
}

.dropdown-toggle .md-ripple:after {
  display: none !important;
}

.dropdown-menu li > a.disabled-link {
  cursor: not-allowed;
  color: #dcdcdc !important;
  pointer-events: none;
}
</style>
